import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import Incidents from "../pages/incidents/page";
import IncidentDetail from "../pages/incident-detail/page";
import Topics from "../pages/topics/page";
import TopicDetail from "../pages/topic-detail/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "incidents", element: <Incidents /> },
      { path: "incident/:id", element: <IncidentDetail /> },
      { path: "topics", element: <Topics /> },
      { path: "topic/:slug", element: <TopicDetail /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;